import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { allReducers } from './reducers';
import { exampleLog } from './middleware/example';

export const store = createStore(
    allReducers,
    undefined,
    compose(
        applyMiddleware(thunk, exampleLog),
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
            process.env.NODE_ENV === 'development'
            ? window.__REDUX_DEVTOOLS_EXTENSION__()
            : a => a,
    ),
);
